<script>
export default {
  name: "toggle",
  props: {
    thisValue: Boolean,
    label: String,
    falseText: String,
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },
};
</script>
<template>
  <div v-on:click="onClick()" :class="isSmallScreen ? 'small-text' : 'normal-text'">
    <span style="margin-right:0.2rem;">{{ label }}</span>
    <label class="switch">
      <input type="checkbox" :checked="thisValue" v-on:click="onClick()" />
      <span class="slider round"></span>
    </label>
  </div>
</template>
<style scoped>
.switch > input:checked + .slider {
  background-color: #2196f3;
}
.switch .switch > input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

.switch > input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.switch > .slider.round {
  border-radius: 17px;
}

.switch > .slider.round:before {
  border-radius: 50%;
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
  top: 2px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.switch > .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch > .slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.normal-text {
  font-size: 0.8rem;
}
.small-text {
  font-size: 11px;
}
</style>
